module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/banner/zh-hant-c4526f792f2bafe09a2266d01d2bb57b.jpg";